//jshint module : true
import actionTypes from './action-types';

export default (state = {}, action) => {
    switch (action.type) {
        case actionTypes.SET_ADS:
            if (!action || !action.type || !action.payload) return state;
            return {
                ...state,
                gpt: action.payload.gpt,
                adSenseQuery: action.payload.adSenseQuery,
                adSenseShoppingPublisherId:
                    action.payload.adSenseShoppingPublisherId
            };
        case actionTypes.SET_TCF_LOADED:
            return {
                ...state,
                isTcfLoaded: true
            };

        default:
            return state;
    }
};
